import { createFileRoute } from '@tanstack/react-router';

import { SessionsListPage } from '~pages/sessions/sessions-list-page';

export const Route = createFileRoute('/_auth/_layout/sessions/')({
  component: SessionsListPage,
});
